<!-- COVERS -->
<div class="covers-container">
  <div *ngFor="let cover of covers; let index = index" class="select"
  [ngClass]="{
    'select--success': !!dni[cover.type]
  }">
    <div class="select__title">
      {{ cover.i18n | translate }}
    </div>

    <div
      class="select__box"
      [ngClass]="{
        'select__box--success': !!dni[cover.type],
        'mapfre-hide-mobile': !!dni[cover.type]
      }"
      (dragenter)="onDragEnter($event)"
      (dragover)="onDragEnter($event)"
      (drop)="onDrop($event, index)"
    >
      <div class="select__icon-box">
        <ng-container *ngIf="cover.loading; else imageBig">
          <ion-spinner *ngIf="cover.loading" name="crescent"></ion-spinner>
        </ng-container>
        <ng-template #imageBig>
          <img
            class="select__icon-clip"
            *ngIf="!dni[cover.type]"
            [src]="attachIcon"
            alt="Clip adjuntar"
          />
          <img
            class="select__icon-success"
            *ngIf="!!dni[cover.type]"
            [src]="attachSuccessIcon"
            alt="Check correcto"
          />
        </ng-template>
      </div>

      <div class="select__btn-box">
        <ion-button
          class="select__btn"
          color="primary"
          fill="outline"
          size="medium"
          mat-button
          [disabled]="!!dni[cover.type]"
          (click)="onSelect(index)"
        >
          <ng-container *ngIf="cover.loading; else imageSmall">
            <ion-spinner *ngIf="cover.loading" name="crescent"></ion-spinner>
          </ng-container>
          <ng-template #imageSmall>
            <img
              *ngIf="!dni[cover.type]"
              [src]="attachIcon"
              alt="Clip adjuntar"
            />
            <img
              *ngIf="!!dni[cover.type]"
              [src]="attachSuccessIcon"
              alt="Check correcto"
            />
          </ng-template>
          {{ 'UPDATE_DOC.ORIGIN.' + origin | translate | uppercase}}
        </ion-button>

        <div
          class="select__trigger"
          #menuTrigger="matMenuTrigger"
          [matMenuTriggerFor]="menu"
        ></div>
      </div>

      <mat-menu #menu="matMenu">
        <button mat-menu-item (click)="askFileThroughCamera(index)">
          {{ 'UPDATE_DOC.CAMERA' | translate }}
        </button>
        <button mat-menu-item (click)="askFileThroughGallery(index)">
          {{ 'UPDATE_DOC.GALLERY' | translate }}
        </button>
      </mat-menu>

      <input
        #input
        class="select__input"
        type="file"
        accept="image/*"
        hidden
        (change)="onFileSelectedFromGallery($event?.target?.files, index)"
      />

      <div *ngIf="!platform.is('cordova')" class="select__label">
        {{ 'UPDATE_DOC.DRAG_LABEL' | translate }}
      </div>
    </div>

    <div class="select__box--success" *ngIf="ctx.isApp">
      <img
      *ngIf="!!dni[cover.type]"
      [src]="attachSuccessIcon"
      alt="Check correcto"
    />
    </div>

  </div>
</div>

<!-- LIST OF IMAGES -->
<mapfre-document-item
  *ngFor="let file of files"
  [document]="{ name: file.label }"
  documentIconUrl="assets/images/document.svg"
  [showButtonDelete]="true"
  [showDocumentSize]="false"
  [showButtonDownload]="false"
  (action)="onClickItem(file)"
  (delete)="onDeleteItem(file)"
></mapfre-document-item>
